'use client';
import { sortLabelName } from 'components/associated-dealers/utils';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { dealerAssociationAction } from 'services/request-service/action';

const RequestServiceContext = createContext(null);
export const useRequestEquipmentService = () =>
  useContext(RequestServiceContext);

export const RequestEquipmentServiceProvider = ({ children }) => {
  const [isRSModalOpen, setIsRSModalOpen] = useState(false);
  const [equipmentInfo, setEquipmentInfo] = useState([]);
  const [dealerAssociation, setDealerAssociation] = useState([]);

  const getDealerAssociation = async () => {
    const { associations } = await dealerAssociationAction();
    const dealerList = associations
      ?.map((association) => {
        return {
          label: association.dealerName,
          value: association.id,
          isDefault: association.isDefault
        };
      })
      .sort(sortLabelName);
    setDealerAssociation(dealerList);
  };

  useEffect(() => {
    getDealerAssociation();
  }, []);

  const contextValue = useMemo(
    () => ({
      isRSModalOpen,
      setIsRSModalOpen,
      equipmentInfo,
      setEquipmentInfo,
      dealerAssociation
    }),
    [equipmentInfo, isRSModalOpen, dealerAssociation]
  );

  return (
    <RequestServiceContext.Provider value={contextValue}>
      {children}
    </RequestServiceContext.Provider>
  );
};
